import React from 'react';
import Button from '../../components/Button';

export default function WayfinderProBanner() {
  return (
    <section
      id='wayfinder-pro'
      className='flex items-center justify-center py-52 border-y border-white/8 bg-[url("./assets/images/backgrounds/pro-graphic-mobile.webp")] md:bg-[url("./assets/images/backgrounds/pro-graphic-desktop.webp")] bg-cover bg-center bg-no-repeat px-6'
    >
      <div className='w-full max-w-5xl flex justify-center md:justify-start'>
        <div className='max-w-96 flex flex-col items-center md:items-start'>
          <div className='space-y-4 mb-6 md:text-left text-center'>
            <h2 className='text-4.5xl font-semibold leading-[141%] whitespace-nowrap'>
              Unlock more power{' '}
            </h2>
            <p className='text-white/60 text-lg md:text-base'>
              Unlock the full power of Wayfinder with Pro. More messages, lower
              fees, extra agents, and priority access to new features.
            </p>
          </div>
          <Button color='yellow' size='lg' href='https://app.wayfinder.ai/pro'>
            Get Pro
          </Button>
        </div>
      </div>
    </section>
  );
}
